export const FILTERABLE_CARD_DEFAULT_SIZE = {
  lg: 3,
  md: 4,
  xs: 12,
} as const;
